import clsx from 'clsx';
import { default as MUISlider, SliderProps as MUISliderProps } from '@material-ui/core/Slider';

//
// --- Types ---

export interface SliderProps extends Omit<MUISliderProps, 'onChange' | 'onChangeCommitted'> {
  'data-testid'?: string;
  onChange?: (event: React.SyntheticEvent, newValue: number | number[]) => void;
  onChangeCommitted?: (event: React.SyntheticEvent, newValue: number | number[]) => void;
}

//
// --- Slider Component ---

/**
 * Wrapper for all slider components. This component also addresses issues with incorrect
 * typings on onChange and onChangeCommitted callbacks by the Material-UI library. These types
 * will not be fixed in version 4.x
 */
const Slider: React.FC<SliderProps> = props => {
  const {
    className,
    'data-testid': dataTestId = 'slider',
    onChange,
    onChangeCommitted,
    ...remainingMUISliderProps
  } = props;

  return (
    <MUISlider
      className={clsx('slider', className)}
      data-testid={dataTestId}
      onChange={onChange as any}
      onChangeCommitted={onChangeCommitted as any}
      {...remainingMUISliderProps}
    />
  );
};

export default Slider;
